import React, { useEffect, useState } from 'react';
import SelectorMultiple from '../../../../../shared/Components/Selectores/Multiple';
import {createOptions} from './functions';


export const SelectorVehiculosMultiple = (props:any) =>{

  let {options, selectedOptions, isDisabled, onChange} = props;
  let [comboOptions, setComboOptions] = useState(options)

  useEffect(()=>{
    if(options){
      setComboOptions(createOptions(options))
    }
  },[options])

  useEffect(()=>{
    if(isDisabled){
      onChange && onChange([])
    }
  },[isDisabled])

  useEffect(()=>{
    if(comboOptions  && comboOptions.length>0)
    {
      let select = !Array.isArray(selectedOptions) ? comboOptions.filter((o:any) => o.value===selectedOptions) : selectedOptions
      onChange && onChange(select)
    }
  },[comboOptions])
 
  return (
    <SelectorMultiple {...{...props,...{options:(comboOptions)}}} id="selectVehiculos"/>
  )
}
export default SelectorVehiculosMultiple